export default {
  actions: {},
  mutations: {
    updateDiseaseSearchRequest(state, searchRequest) {
      state.diseaseSearchRequest = searchRequest
    }
  },
  state: {
    diseaseSearchRequest: ''
  },
  getters: {
    diseaseSearchRequest(state) {
      return state.diseaseSearchRequest
    }
  }
}